import { Component } from '@angular/core';

@Component({
  selector: 'app-engineer-tracking',
  imports: [],
  templateUrl: './engineer-tracking.component.html',
  styleUrl: './engineer-tracking.component.scss',
})
export class EngineerTrackingComponent {}
